import { AspectRatioBox, Icon, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function UploadImageButton({ onUpload, error = false, disabled = false }) {
  const { t } = useTranslation();
  return (
    <AspectRatioBox ratio="1:1">
      <S.UploadImageButtonWrapper error={error} disabled={disabled}>
        <S.UploadButton onClick={onUpload}>
          <Icon name="upload" size="lg" />
          <Typography variant="body2SemiBold">{t('upload')}</Typography>
        </S.UploadButton>
      </S.UploadImageButtonWrapper>
    </AspectRatioBox>
  );
}

UploadImageButton.propTypes = {
  onUpload: PropTypes.func,
  error: PropTypes.bool,
  disabled: PropTypes.bool
};

export { UploadImageButton };
